var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-search",
    {
      attrs: { name: _vm.name, placeholder: _vm.placeholderText },
      model: {
        value: _vm.countryName,
        callback: function($$v) {
          _vm.countryName = $$v
        },
        expression: "countryName"
      }
    },
    [
      _c("q-autocomplete", {
        attrs: {
          "static-data": { field: "label", list: _vm.countries },
          debounce: _vm.defaultSearchDebounce,
          "min-characters": 0,
          "max-height": "200px",
          "max-results": 500,
          "value-field": function(v) {
            return v.label
          }
        },
        on: { selected: _vm.selected }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }